import React, { useState, useEffect } from "react";
import axios from 'axios';
import { Table } from 'react-bootstrap';
import './Main.css';
import TopNav from './TopNav';
import MainNav from './MainNav';
import LoginCheck from '../util/LoginCheck';
import ButtonStyle from '../util/ButtonStyle';
import { confirmAlert } from 'react-confirm-alert';
import NumberFormat from 'react-number-format';
import paymentData from '../util/paymentData.json';
import { useSelector } from 'react-redux';
import moment from 'moment';

const initialState = {
    center : '',
    location : '',
    name : '',
    phone : '',
    itemName1 : '',
    itemName2 : '',
    price1 : '',
    price2 : '',
    refund_sdate : '',
    refund_edate : '',
    use_day : ''
}

export default function RefundInfo({match}) {
    const seq = match.params.seq;
    const [refundInfo, setRefundInfo] = useState(initialState);
    const [refundMoney,setRefundMoney] = useState([]);
    const data = useSelector(state => state.data);

    let mode = 'server';
    let node_api = 'https://api.smartg.kr:3000'
    if(mode === 'local'){
        node_api = "http://192.168.76.23:3000"
    }

    function getRefundDetailInfo(){
        axios({
            url : node_api + "/refund/get_refund_detail",
            method : "post",
            data : {
                seq : seq
            }
        }).then(function (res){
            console.log(res.data.rows);
            var temp = res.data.rows[0];
            console.log(res.data.rows[0]);
            
            var year2 = res.data.rows[0].sdate.substring(0, 4);
            var month2 = res.data.rows[0].sdate.substring(4, 6);
            var day2 = res.data.rows[0].sdate.substring(6, 8);
            temp["formatSdate"]= year2 + '-' + month2 + "-" + day2;

            var year3 = res.data.rows[0].edate.substring(0, 4);
            var month3 = res.data.rows[0].edate.substring(4, 6);
            var day3 = res.data.rows[0].edate.substring(6, 8);
            temp["formatEdate"] = year3 + '-' + month3 + "-" + day3;
            setRefundInfo(temp);
        }).catch(function(error){
            console.log(error);
        })
    }

    function getRefundPriceInfo() {
        axios({
            url : node_api + "/refund/get_refund_price",
            method : "post",
            data : {
                seq : seq
            }
        }).then(function (result){
            setRefundMoney(result.data.rows);
        }).catch(function (error){
            console.log(error);
        })
    }

    function deleteRefund(){
        axios({
            url : node_api+ "/refund/delete_refund",
            method : "post",
            data : {
                seq : seq
            }
        }).then(function (response){
            alert("삭제되었습니다.");
            window.location.href = '/refund';
        }).catch(function (error){
            console.log(error);
        })
    }

    function moveList(){
        window.location.href = '/refund';
    }

    function moveEdit(){
        window.location.href = '/refundInfoEdit/'+seq;
    }

    function handleDelete() {
        confirmAlert({
            title: '삭제 확인',
            message: refundInfo.name + "님의 환불 신청 정보를 삭제하시겠습니까?",
            buttons: [
              {
                label: 'Yes',
                onClick: () => deleteRefund()
              },
              {
                label: 'No'
              }
            ]
          });
    }


    async function main() {
        const result = await LoginCheck(data.url);
        if(result === "Y"){
            getRefundDetailInfo();
            getRefundPriceInfo();
        }
    }

    useEffect(()=>{
        main();
    },[]);

    return (
        <main className="main-container">
            <TopNav />
            <div className="content-wrapper">
            <MainNav />
            <div className="content-inner">
            <h3>환불 상세정보</h3>
            <div className="content-component">
                <div className="content-header">
                </div>
                <div className="content-body client-info">
                <div className="info-table-left text-left">
                <h5>구매정보</h5>
                <Table bordered>
                    <tbody>
                        <tr>
                            <td>가맹점</td>
                            <td>{refundInfo.center +" "+ refundInfo.location}</td>
                        </tr>
                        <tr>
                            <td>고객명</td>
                            <td>
                                {refundInfo.name}
                            </td>
                        </tr>
                        <tr>
                            <td>연락처</td>
                            <td>
                                {refundInfo.phone}
                            </td>
                        </tr>
                        <tr>
                            <td>상품</td>
                            <td>
                            <table className="inner-table">
                                <tbody>
                                    <tr>
                                        <td>종목</td>
                                        <td>
                                            {refundInfo.itemName1 + " " + refundInfo.itemName2}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>구매가</td>
                                        <td>
                                            <NumberFormat value={refundInfo.price2} displayType={'text'} thousandSeparator={true} suffix={'원'} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>유효기간</td>
                                        <td>
                                            {refundInfo.formatSdate}
                                        <span>&nbsp;~&nbsp;</span>
                                            {refundInfo.formatEdate}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </td>
                        </tr>
                    </tbody>
                </Table>
                <h5>이용정보</h5>
                <Table bordered>
                    <tbody>
                        <tr>
                            <td>이용시작일</td>
                            <td>{moment(refundInfo.refund_sdate).format('YYYY-MM-DD')}</td>
                        </tr>
                        <tr>
                            <td>이용종료일</td>
                            <td>
                                {moment(refundInfo.refund_edate).format('YYYY-MM-DD')}
                            </td>
                        </tr>
                        <tr>
                            <td>이용일</td>
                            <td>
                                {refundInfo.use_day+"일"}
                            </td>
                        </tr>
                    </tbody>
                </Table>
                <div className="button-container">
                    <ButtonStyle mode="list" title="목록" buttonClick={() => moveList()}/>
                    <ButtonStyle mode="edit" title="수정" buttonClick={() => moveEdit()}/>
                    <ButtonStyle mode="delete" title="삭제" buttonClick={() => handleDelete()}/>
                </div>
                </div>
                <div className="info-table-right">
                    <h5>환불 신청 기본 정보</h5>
                    <Table bordered className="refund-table">
                        <tbody>
                            <tr>
                                <td>고객명</td>
                                <td>
                                    {refundInfo.refundName}
                                </td>
                            </tr>
                            <tr>
                                <td>휴대전화</td>
                                <td>
                                    {refundInfo.refundPhone}
                                </td>
                            </tr>
                            <tr>
                                <td>환불사유</td>
                                <td>
                                    {refundInfo.reason}
                                </td>
                            </tr>
                            <tr>
                                <td>환불계좌정보</td>
                                <td>
                                <table className="inner-table">
                                    <tbody>
                                        <tr>
                                            <td>은행명</td>
                                            <td>
                                                {refundInfo.accountBank}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>계좌번호</td>
                                            <td>
                                                {refundInfo.accountNum}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>소유주</td>
                                            <td>
                                                {refundInfo.accountName}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                </td>
                            </tr>
                            <tr>
                                <td>신청상태</td>
                                <td>{refundInfo.state}</td>
                            </tr>
                            <tr>
                                <td>지점 담당자</td>
                                <td>{refundInfo.manager}</td>
                            </tr>
                        </tbody>
                    </Table>

                    <h5>환불 신청 상세 정보</h5>
                    <Table bordered className="refund-table-detail">
                        <tbody>
                            <tr>
                                <td>항목</td>
                                <td>금액</td>
                            </tr>
                            {
                                refundMoney.map((item, index) => {
                                    return(
                                        <tr>
                                            <td>{item.memo}</td>
                                            <td><NumberFormat value={item.amount} displayType={'text'} thousandSeparator={true} suffix={'원'} /></td>
                                        </tr>
                                    )
                                })
                            }
                            <tr>
                                <td style={{borderTop : '2px solid #333'}}>환불예상금액</td>
                                <td style={{backgroundColor : '#eee', borderTop : '2px solid #333 '}}><NumberFormat value={refundInfo.final_amount} displayType={'text'} thousandSeparator={true} suffix={'원'} /></td>
                            </tr>
                        </tbody>
                    </Table>

                </div>
                </div>
            </div>
            </div>
            </div>
        </main>
    )
}